/**
 * ============================================================================
 * ProgramSelectorBanner — Service (API calls)
 * ============================================================================
 * Pure fetch wrappers. Local OTP (/api/otp/send + verify) — NOT OTPContext.
 * Lead create / proceed reuse leadSquareApiCallFlow / BothFlow.
 * ============================================================================
 */

import {
  leadSquareApiCallBothFlow,
  leadSquareApiCallFlow,
} from "@/utils/SFAPICall";

export interface SendOtpResult {
  success: boolean;
  hash?: string;
  message?: string;
}

export interface VerifyOtpResult {
  success: boolean;
  message?: string;
}

/** POST /api/otp/send — local OTP (not OTPContext). */
export async function sendLocalOtp(mobile: string): Promise<SendOtpResult> {
  const res = await fetch("/api/otp/send", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ mobile }),
  });
  const data = await res.json();
  if (data?.success) {
    return {
      success: true,
      hash: data?.data?.hash || data?.hash,
    };
  }
  return {
    success: false,
    message: data?.message || "Failed to send OTP. Please try again.",
  };
}

/** POST /api/otp/verify — local OTP verify. */
export async function verifyLocalOtp(payload: {
  hash?: string;
  mobile?: string;
  otp: string;
}): Promise<VerifyOtpResult> {
  const res = await fetch("/api/otp/verify", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (data?.success) {
    return { success: true };
  }
  return {
    success: false,
    message: data?.message || "Incorrect OTP. Please try again.",
  };
}

/** Initial lead after form/OTP — leadSquareApiCallFlow. */
export function submitProgramSelectorLead(
  form: Record<string, any>,
  extraPayload: Record<string, any> | false = {},
) {
  return leadSquareApiCallFlow(form, extraPayload || {});
}

/** Proceed with degree (+ optional cert) selection. */
export function proceedProgramSelectorLead(options: {
  degreeForm: Record<string, any>;
  certForm?: Record<string, any>;
  withCert: boolean;
}) {
  const { degreeForm, certForm, withCert } = options;
  if (withCert && certForm) {
    return leadSquareApiCallBothFlow(degreeForm, certForm);
  }
  return leadSquareApiCallFlow(degreeForm);
}
